import { GET_INDOOR_ZONE_DATA_FOR_LEVEL } from '@/store/action-types'
import { useAccessStore } from '@/pinia/access'
import { getSensordata } from '@/services/sensorData.service'

import { getZoneCategories, getZoneTypeFeaturesV2 } from '@/services/zones.service'
import i18n from '../../../i18n'
import { useIotCoverageStore } from '@/pinia/iotCoverage'
const { t } = i18n.global

export default {
  async [GET_INDOOR_ZONE_DATA_FOR_LEVEL]({ commit, state }, payload) {
    const filteredLayers = [...state.filteredLayers]
    const isTypeDataAlreadyFetched = state.indoorZonesForSelectedLevel.some(
      (feature) => feature.properties.typeId === payload.typeId
    )
    if (!isTypeDataAlreadyFetched) {
      const zoneFeaturesForType = await getZoneTypeFeaturesV2(
        payload.levelId,
        payload.categoryId,
        payload.typeId
      )
      if (!zoneFeaturesForType) return
      const selectedType = zoneFeaturesForType.filter(
        (type) => type.properties.typeId === payload.typeId
      )
      const existingZonesArray = state.indoorZonesForSelectedLevel
      const zonesArray = existingZonesArray.concat(selectedType)
      commit('SET_INDOOR_ZONE_DATA_FOR_LEVEL', { zones: zonesArray })
      const zoneCategory = state.filteredLayers.find(
        (category) => category.id === payload.categoryId
      )
      const zoneTypeInfo = zoneCategory.types.find((type) => type.id === payload.typeId)
      zoneTypeInfo.visible = payload.checked
      zoneCategory.visible =
        zoneCategory.types.filter((x) => x.visible === true).length === zoneCategory.types.length
    }

    if (isTypeDataAlreadyFetched) {
      for (const layer of filteredLayers) {
        for (const type of layer.types) {
          if (type.id === payload.typeId) {
            type.visible = payload.checked
            layer.visible =
              layer.types.filter((x) => x.visible === true).length === layer.types.length
          }
        }
      }
    }
    commit('SET_FILTERED_PLANVIEW_LAYERS', { filteredLayers })
  },
  async loadSensorData({ dispatch }) {
    if (useAccessStore().hasSensorDataAccess) await dispatch('getSensordataForSelectedLevel')
  },
  async onLevelChange({ commit }, levelId: string) {
    commit('SET_INDOOR_ZONE_DATA_FOR_LEVEL', { zones: [] })
    if (useAccessStore().hasZoneAccess) {
      const zoneCategoriesForSelectedLevel = await getZoneCategories(levelId)
      if (zoneCategoriesForSelectedLevel) {
        commit('SET_ZONE_CATEGORIES_FOR_SELECTED_LEVEL', {
          categories: zoneCategoriesForSelectedLevel.data.content
        })
        const filteredLayers: object[] = []
        for (const category of zoneCategoriesForSelectedLevel.data.content) {
          for (const type of category.types) {
            type.visible = false
            type.disabled = false
          }
          filteredLayers.push({
            disabled: false,
            id: category.id,
            name: category.name,
            types: category.types,
            visible: false
          })
        }
        commit('SET_FILTERED_PLANVIEW_LAYERS', { filteredLayers })
      }
    }
  },
  async getSensordataForSelectedLevel({ commit, rootState }) {
    const { levels } = useIotCoverageStore()
    try {
      commit('setSensordataTypes', [])
      commit('setSensordataForSelectedLevel', [])
      if (!levels.includes(rootState.selectedLevel.id)) return
      commit('setIsLoadingSensordata', true)
      const sensorDataLevel = await getSensordata(rootState.selectedLevel.id, true, 15000)
      const uniqueMeasureTypes: string[] = []
      for (const roomValues of sensorDataLevel.values) {
        for (const value of roomValues.values) {
          if (!uniqueMeasureTypes.includes(value.measures)) uniqueMeasureTypes.push(value.measures)
        }
      }
      commit('setSensordataTypes', uniqueMeasureTypes)
      commit('setSensordataForSelectedLevel', sensorDataLevel.values)
    } catch (e: any) {
      if (e.constructor.name !== 'Cancel')
        commit(
          'setInfoMessage',
          { type: 'error', message: t('message__sensor-data-fetch-error') },
          { root: true }
        )
      commit('setSensordataForSelectedLevel', [])
      console.error(e)
    } finally {
      commit('setIsLoadingSensordata', false)
    }
  }
}
